import angular from 'angular';

export default angular
	.module('ui.cian.ng-form-submit', [])
	.directive('cianUiNgFormSubmit', () => ({
		restrict: 'A',
		require: ['cianUiNgFormSubmit', 'form'],
		link: (scope, element, attrs, ctrls) => {
			ctrls[0].init(ctrls[1]);
		},
		controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
			let submitButton;

			this.setSubmitButton = element => submitButton = element;

			this.init = form => {
				$scope.$watch(() => {
					return form.$$parentForm.$submitted; // eslint-disable-line angular/no-private-call
				}, newValue => {
					if (newValue) {
						form.$submitted = true;
					}
				});

				this.submit = () => {
					$scope.$apply(() => {
						$scope.$eval($attrs.cianUiNgFormSubmit);
						form.$submitted = true;
					});
				};

				if (!$attrs.cianUiNgFormNoEnterSubmit) {
					$element.bind('keydown', event => {
						if (event.which === 13) {
							if (!submitButton.disabled) {
								this.submit();
							}
							event.preventDefault();
						}
					});
				}
			};
		}]
	}))
	.directive('cianUiNgFormSubmitButton', () => ({
		restrict: 'A',
		require: ['cianUiNgFormSubmitButton', '^cianUiNgFormSubmit'],
		link: (scope, element, attrs, ctrls) => {
			ctrls[0].init(ctrls[1]);
		},
		controller: ['$element', function ($element) {
			this.init = ngFormSubmit => {
				ngFormSubmit.setSubmitButton($element[0]);

				$element.on('click', () => ngFormSubmit.submit());
			};
		}]
	}))
	.name;
